// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","content":"footer-module--content--24Vsb"};